import React from 'react';
import { BookOpenIcon, FootprintsIcon, GiftIcon, RefreshCwIcon, ShieldCheckIcon, SmartphoneIcon } from 'lucide-react';
import { productName, trustSignals, TrustSignal } from '../data/copy';
const icons: Record<TrustSignal['icon'], typeof GiftIcon> = {
  access: SmartphoneIcon,
  pages: BookOpenIcon,
  sessions: FootprintsIcon,
  bonuses: GiftIcon,
  guarantee: ShieldCheckIcon,
  updates: RefreshCwIcon
};
export function Footer() {
  return <footer className="defer-paint w-full bg-navy pb-24 pt-14 sm:pb-12" data-id="element-107" data-mp="3uftmvpyt3y1e">
      <div className="mx-auto max-w-5xl px-6 text-center" data-id="element-108" data-mp="37o74x94c1ef">
        <p className="font-display text-xl font-bold text-white" data-id="element-109" data-mp="3lec9wggp4cgx">{productName}</p>
        <p className="mt-2 text-sm text-muted" data-id="element-110" data-mp="3lgopimyzeaqt">
          Complete Track &amp; Field Training &amp; Management System · For
          Coaches, Teachers &amp; Athletics Directors Worldwide
        </p>

        <ul className="mx-auto mt-10 grid max-w-3xl grid-cols-2 gap-x-6 gap-y-5 text-left sm:grid-cols-3" data-id="element-111" data-mp="2a1jm1gr10865">
          {trustSignals.map(signal => {
          const Icon = icons[signal.icon];
          return <li key={signal.label} className="flex items-start gap-3 text-sm text-white" data-id="element-112" data-mp="3lbdecxo1ahnx">
                <Icon className="mt-0.5 h-5 w-5 shrink-0 text-gold" strokeWidth={2} aria-hidden="true" data-id="element-113" data-mp="3gck0v58qyqnr" />
                {signal.label}
              </li>;
        })}
        </ul>

        <div className="mx-auto mt-10 max-w-3xl space-y-1 border-y border-navy-line py-6 text-xs font-medium uppercase tracking-wider text-muted" data-id="element-114" data-mp="3q725cclzmq8m">
          <p data-id="element-115" data-mp="3474fms9a7yq">Secure Checkout · SSL Encrypted · Money-Back Guarantee</p>
          <p data-id="element-116" data-mp="31uqrltj6jrh">No Hidden Charges · No Recurring Billing · One-Time Payment</p>
        </div>

        <p className="mt-8 text-xs text-muted" data-id="element-117" data-mp="hs1wr22cqaba">
          © {productName} 2026 — All Rights Reserved
        </p>
        <p className="mx-auto mt-3 max-w-2xl text-xs leading-relaxed text-muted" data-id="element-118" data-mp="cvtlhzr9z19e">
          This is a digital coaching resource for track and field coaches.
          Results depend on how the system is applied in training. Individual
          athlete development depends on coaching quality, athlete commitment,
          and consistency of implementation.
        </p>
      </div>
    </footer>;
}